import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { AniSlideUp } from '@/components/shared/animations/basic';

import { useSafetyEvidenceMetrics } from '../useSafetyPageData';

/**
 * ### SafetyEvidenceFigure
 *
 * States the three Safety credentials — the TTA-certified F1-score, the
 * patents, and the research venue — each next to the scope it holds under,
 * in the same divided three-column list the Industrial page uses for its
 * production figures. The scope is part of the same block as the value, not
 * a footnote: a figure read apart from its scope becomes a claim about every
 * deployment.
 *
 * @returns The rendered credentials list element
 * @see {@link useSafetyEvidenceMetrics} The credentials rendered here
 */
export default function SafetyEvidenceFigure() {
  const { t } = useTranslation('common');
  const metrics = useSafetyEvidenceMetrics(t);

  return (
    <ul className="flex flex-col gap-[24px] lg:grid lg:grid-cols-3 lg:gap-[40px]">
      {metrics.map((metric, index) => (
        <AniSlideUp key={metric.label} delay={0.15 * index} element="li">
          <div className="h-full border-t border-t-apps-brandGray50 pt-[24px] lg:pt-[32px]">
            <p className="text-[clamp(40px,3.333vw,56px)] font-bold leading-[120%] tracking-[-1.12px] text-apps-brandGrayWhite">
              {metric.value}
            </p>
            <h3 className="mt-[12px] text-[20px] font-bold leading-[140%] tracking-[-0.4px] text-apps-coreGrayWhite lg:text-[22px] lg:tracking-[-0.44px]">
              {metric.label}
            </h3>
            <p className="mt-[8px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:text-[18px] lg:leading-[160%] lg:tracking-[-0.36px]">
              {metric.scope}
            </p>
          </div>
        </AniSlideUp>
      ))}
    </ul>
  );
}
